import { instance as axios } from '../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { PlanRule } from 'src/models/planRules';

//================|| PLAN RULES SLICE ||=================//

type PlanRulesState = {
    loading: boolean;
    error: ErrorInformation;
    planRuleList: PlanRule[];
}

const initialState: PlanRulesState = {
    loading: true,
    error: null,
    planRuleList: []
};

export const getPlanRuleList = createAsyncThunk<PlanRule[], { type: string }, { rejectValue: ErrorInformation }>(
    "planRules/getPlanRuleList",
    async ({ type }, { rejectWithValue }) => {
        try {
            const planRuleListResponse = await axios.get<PlanRule[]>(`/Misc/getDocumentByType?type=${type}`);
            console.log(planRuleListResponse.data)
            return planRuleListResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }

    }
)

export const getPlanRuleDetail=createAsyncThunk<any, { DocId: number }, { rejectValue: ErrorInformation }>(
    "planRules/getPlanRuleDetail",
    async ({ DocId }, { rejectWithValue }) => {
        try {
            const planRuleDetailResponse = await axios.get<any>(`/Misc/getDocumentById?DocId=${DocId}`,{responseType:'blob'});
            return planRuleDetailResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }

    }
)
const planRulesSlice = createSlice({
    name: 'planRules',
    initialState,
    reducers: {},
    extraReducers: {
        //get plan rule list
        [getPlanRuleList.pending.type]: (state) => {
            state.loading = true;
        },
        [getPlanRuleList.fulfilled.type]: (state, action: PayloadAction<PlanRule[]>) => {
            state.planRuleList = action.payload
            console.log( state.planRuleList)
            state.loading = false;
        },
        [getPlanRuleList.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get plan rule detail
        [getPlanRuleDetail.pending.type]: (state) => {
            state.loading = true;
        },
        [getPlanRuleDetail.fulfilled.type]: (state) => {
            state.loading = false;
        },
        [getPlanRuleDetail.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
    }
})

export default planRulesSlice